import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import BlogPost from '../BlogCard';

export const Wrapper = styled.div``;

export const StyledContainer = styled(Container)`
  &.reduced-margin {
    margin-top: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    .blog-post {
      > div {
        flex-direction: row;
      }

      &:nth-child(4n + 1),
      &:nth-child(4n + 2) {
        > div {
          flex-direction: row-reverse;
        }
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 0 90px;
  }
`;

export const StyledBlogPost = styled(BlogPost)``;

export const ViewMore = styled.button`
  min-height: 48px;
  width: 100%;
  border-radius: 6px;
  background-color: ${themeGet('colors.secondary')};
  color: ${themeGet('colors.text-primary')};
  font-size: 18px;
  font-weight: bold;
  font-family: ${themeGet('fonts.primary')};
  letter-spacing: 0.23px;
  line-height: 24px;
  text-align: center;

  &&:disabled {
    cursor: not-allowed;
    background-color: ${themeGet('colors.pale-grey')};
    color: ${themeGet('colors.grey')};

    &:hover,
    &:focus {
      cursor: not-allowed;
      background-color: ${themeGet('colors.pale-grey')};
    }
  }
`;

export const NoResults = styled.p`
  text-align: center;
  margin: 30px 0 50px;
`;
